import { useState } from 'react';
import { getDeviceTimeZone, listTimeZoneNames } from './offerTimeZoneConversion';

const STORAGE_KEY = 'offerFormTimeZone';

function readStoredTimeZone(): string {
  let stored: string | null = null;
  try {
    stored = localStorage.getItem(STORAGE_KEY);
  } catch {
    stored = null;
  }
  return stored && listTimeZoneNames().includes(stored) ? stored : getDeviceTimeZone();
}

// The React state below is only this component instance's own copy, re-read from localStorage on
// every fresh mount -- the form and the list agree because both start from the same stored value,
// not because they share one running instance of this hook.
export function usePersistedDisplayTimeZone() {
  const [timeZone, setTimeZoneState] = useState(readStoredTimeZone);

  const setTimeZone = (nextTimeZone: string) => {
    setTimeZoneState(nextTimeZone);
    try {
      localStorage.setItem(STORAGE_KEY, nextTimeZone);
    } catch {
      // Worst case the operator re-picks their zone next visit -- not worth failing the save.
    }
  };

  return { timeZone, setTimeZone };
}
